import script from "./active-terminal-ranking-chart.vue?vue&type=script&setup=true&lang=ts"
export * from "./active-terminal-ranking-chart.vue?vue&type=script&setup=true&lang=ts"

import "./active-terminal-ranking-chart.vue?vue&type=style&index=0&id=29e50992&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29e50992"]])

export default __exports__